/* KAIROS 2026-09-26: product history only. No network requests or sliders here. */
(() => {
  'use strict';
  if (window.KairosRecentlyViewedHistoryV2) return;
  window.KairosRecentlyViewedHistoryV2 = true;

  const KEY = 'recently-viewed';
  const validHandle = value => value.length <= 255 && /^[\p{L}\p{N}][\p{L}\p{N}_-]*$/u.test(value);

  function remember() {
    // Never record a card/quick-view request as a separate product visit.
    if (new URLSearchParams(location.search).has('view')) return;
    const match = location.pathname.match(/\/products\/([^/]+)\/?$/);
    const product = document.querySelector('[id^="MainProduct-"][data-product-handle]');
    if (!match || !product) return;
    const handle = product.dataset.productHandle || '';
    try {
      if (!validHandle(handle) || decodeURIComponent(match[1]) !== handle) return;
      const previous = localStorage.getItem(KEY) || '';
      const handles = [handle, ...previous.slice(0, 16384).split(',').map(value => value.trim())];
      const next = [...new Set(handles.filter(validHandle))].slice(0, 20).join(',');
      if (next !== previous) localStorage.setItem(KEY, next);
    } catch (_) {
      // Storage can be unavailable in a private/restricted browser. Shopping still works.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', remember, { once: true });
  } else {
    remember();
  }
  window.addEventListener('pageshow', remember);
  document.addEventListener('shopify:section:load', remember);
})();
